// extracted by mini-css-extract-plugin
export default {"bgContainer":"thirdStep_bgContainer__ZSXus","mainContainerBg":"thirdStep_mainContainerBg__6Byq+","QrContainer":"thirdStep_QrContainer__Wy6LI"};